import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { setLocalStoreModel } from "../store/slices/local-store";
var useLocalStore = function (path) {
    var dispatch = useDispatch();
    var model = useSelector(function (state) { return _.get(state.localStore.model, path); });
    var setStore = function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        if (arg.length < 2) {
            dispatch(setLocalStoreModel({ path: path, model: arg[0] }));
        }
        else if (arg.length === 2) {
            dispatch(setLocalStoreModel({ path: path + '.' + arg[0], model: arg[1] }));
        }
    };
    var select = function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        if (arg.length < 2) {
            return _.get(model, arg[0]);
        }
        else if (arg.length == 2) {
            var partialModel_1 = _.get(model, arg[0]);
            return function (key) { return _.get(partialModel_1, key); };
        }
    };
    return { model: model, select: select, setStore: setStore };
};
export default useLocalStore;
